import { request, RequestError, RequestErrorType } from '../../request';

function formatPwd(pwd) {
  return {
    ...pwd,
    text: Array.isArray(pwd.text) ? pwd.text : [pwd.text],
  };
}

/**
 *
 * @param { pageId, jumpUrl, title, overlapUrl } 无极配置的页面id，跳转的链接，识别弹窗的描述，模板5的小图
 * @returns
 */
export function getPwd({ pageId, jumpUrl, title, overlapUrl, reimgUrl }) {
  const params = {
    pageid: pageId,
    jumpurl: jumpUrl,
    overlapUrl,
    key1: title,
    reimgUrl,
  };
  return request(
    'https://vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_magic_activity_kouling&cmd=1&otype=xjson',
    params,
    {
      dataType: 'json',
      xhrFields: {
        withCredentials: true,
      },
      timeout: 3000,
    },
  ).then(
    (res) => {
      if (res.ret !== 0) {
        throw new RequestError(
          res.ret,
          res.msg,
          res,
          RequestErrorType.SYSTEM_ERR,
        );
      }

      const result = {
        weixin: [],
        wxmoments: [],
      };

      try {
        if (res.cmdTextList) {
          result.weixin = JSON.parse(res.cmdTextList);
        }
        if (res.friendTextList) {
          result.wxmoments = JSON.parse(res.friendTextList);
        }
      } catch (e) {
        throw new RequestError(
          -100,
          '数据格式错误',
          res,
          RequestErrorType.SYSTEM_ERR,
        );
      }

      result.weixin.map(formatPwd);
      result.wxmoments.map(formatPwd);

      return result;
    },
    () => {
      throw new RequestError(
        -500,
        '请求失败',
        null,
        RequestErrorType.NETWORK_ERR,
      );
    },
  );
}
